import { confirmDialog } from '@/components/dialogs/DialogHost';

// Ticket 171: manual texts outside the send window come back 409 with
// detail = { code: 'quiet_hours', message, local_time, zone, window }.
// Resending the same body with confirm_quiet_hours: true sends anyway.
export function quietHoursDetail(err) {
  const detail = err?.response?.data?.detail;
  return err?.response?.status === 409 && detail?.code === 'quiet_hours' ? detail : null;
}

// Resolves true when the LO chooses to send anyway.
export async function confirmQuietHours(detail) {
  return confirmDialog({
    title: 'Outside texting hours',
    description: detail.message,
    confirmText: 'Send anyway',
    cancelText: "Don't send",
  });
}
